import React from 'react';

const PdfSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-gray-100 dark:bg-gray-800">
      <div className="w-full h-full border bg-white dark:bg-gray-700 shadow-lg rounded-md overflow-hidden">
        <div className="animate-fadePulse">
          <div className="h-12 bg-gray-300 dark:bg-gray-600" /> 
          <div className="p-4 space-y-4">
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-3/4" />
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/2" />
            <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-2/3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfSkeleton;